export interface Movie {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subcategory: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  episodes: number;
  releaseDate: string;
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
  slug: string;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20featuring%20a%20giant%20space%20station%20orbiting%20Earth%20with%20dramatic%20lighting%2C%20futuristic%20sci-fi%20aesthetic%2C%20warm%20orange%20and%20deep%20space%20contrast%2C%20epic%20scale%2C%20movie%20poster%20style%20with%20bold%20composition&width=800&height=600&seq=movie-01&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙冒险，一群勇敢的宇航员踏上了拯救人类的壮丽征途，在浩瀚星空中书写属于人类的传奇篇章。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '173分钟',
    episodes: 1,
    releaseDate: '2026-02-10',
    featured: true,
    isNew: true,
    isHot: true,
    slug: 'liu-lang-di-qiu-3',
  },
  {
    id: 2,
    title: '封神第二部',
    category: 'movie',
    subcategory: '奇幻',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20elaborate%20armor%2C%20dramatic%20sky%20with%20golden%20and%20crimson%20clouds%2C%20mythical%20creatures%2C%20cinematic%20lighting%2C%20grand%20scale%20composition&width=800&height=600&seq=movie-02&orientation=landscape',
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐西岐武王伐纣。一场人、仙、妖三界大战即将拉开帷幕，天命之战，谁主沉浮？',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    region: '中国大陆',
    duration: '148分钟',
    episodes: 1,
    releaseDate: '2026-01-29',
    featured: true,
    isNew: true,
    isHot: true,
    slug: 'feng-shen-di-er-bu',
  },
  {
    id: 3,
    title: '志愿军：存亡之战',
    category: 'movie',
    subcategory: '战争',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=A%20powerful%20war%20film%20poster%20depicting%20soldiers%20marching%20through%20rugged%20terrain%20under%20dramatic%20skies%2C%20smoke%20and%20dust%20atmosphere%2C%20heroic%20composition%2C%20cinematic%20war%20movie%20aesthetic%20with%20muted%20olive%20and%20earth%20tones&width=800&height=600&seq=movie-03&orientation=landscape',
    description: '抗美援朝战争进入关键阶段，志愿军战士们在极端恶劣的条件下，以钢铁般的意志和血肉之躯，铸就了一道道不可逾越的防线，谱写了一曲气壮山河的英雄赞歌。',
    director: '陈凯歌',
    actors: ['朱一龙', '辛柏青', '张子枫'],
    region: '中国大陆',
    duration: '156分钟',
    episodes: 1,
    releaseDate: '2026-01-01',
    featured: true,
    isNew: false,
    isHot: true,
    slug: 'zhi-yuan-jun-cun-wang-zhi-zhan',
  },
  {
    id: 4,
    title: '哪吒之魔童闹海',
    category: 'anime',
    subcategory: '动画',
    year: 2025,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%20featuring%20a%20young%20mythological%20warrior%20with%20flaming%20hair%20and%20red%20silk%20ribbons%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20ink%20wash%20painting%20style%20with%20modern%20CGI%20elements&width=800&height=600&seq=movie-04&orientation=landscape',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，却遭遇重重困难，哪吒和敖丙的命运将何去何从？',
    director: '饺子',
    actors: ['吕艳婷', '陈浩'],
    region: '中国大陆',
    duration: '144分钟',
    episodes: 1,
    releaseDate: '2025-01-29',
    featured: true,
    isNew: false,
    isHot: true,
    slug: 'ne-zha-zhi-mo-tong-nao-hai',
  },
  {
    id: 5,
    title: '庆余年第二季',
    category: 'tv',
    subcategory: '古装',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20costume%20drama%20poster%20with%20an%20elegant%20scholar%20in%20flowing%20robes%20standing%20in%20an%20ancient%20courtyard%2C%20soft%20natural%20lighting%2C%20traditional%20Chinese%20architecture%20background%2C%20poetic%20and%20mysterious%20atmosphere&width=800&height=600&seq=movie-05&orientation=landscape',
    description: '范闲出使北齐归来，却发现京都局势已经大变。二皇子谋反被诛，长公主被囚，看似平静的京都实则暗流涌动。范闲将如何在权力的漩涡中全身而退？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: 36,
    releaseDate: '2026-05-16',
    featured: false,
    isNew: true,
    isHot: true,
    slug: 'qing-yu-nian-di-er-ji',
  },
  {
    id: 6,
    title: '大奉打更人',
    category: 'tv',
    subcategory: '奇幻',
    year: 2026,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20drama%20poster%20with%20a%20mysterious%20night%20watchman%20holding%20a%20lantern%20in%20ancient%20city%20streets%2C%20foggy%20atmosphere%2C%20traditional%20rooftops%20silhouette%2C%20mystical%20and%20suspenseful%20mood%20with%20teal%20and%20warm%20amber%20lighting&width=800&height=600&seq=movie-06&orientation=landscape',
    description: '现代打工人许七安穿越到大奉王朝，成为一名打更人。在这个妖魔横行、权贵争斗的世界里，他凭借现代人的智慧和勇气，一步步揭开隐藏在京城之下的惊天秘密。',
    director: '邓科',
    actors: ['王鹤棣', '田曦薇'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: 40,
    releaseDate: '2026-06-01',
    featured: false,
    isNew: true,
    isHot: false,
    slug: 'da-feng-da-geng-ren',
  },
  {
    id: 7,
    title: '乘风破浪的姐姐第五季',
    category: 'variety',
    subcategory: '真人秀',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20variety%20show%20poster%20with%20multiple%20confident%20women%20on%20a%20glamorous%20stage%2C%20spotlight%20effects%2C%20sparkling%20costumes%2C%20energetic%20and%20empowering%20atmosphere%2C%20concert%20stage%20with%20vibrant%20lighting&width=800&height=600&seq=movie-07&orientation=landscape',
    description: '三十位30+的姐姐再次集结，用实力和魅力征服舞台。她们在唱跳中突破自我，在竞争中互相扶持，展现属于成熟女性的独特光芒。',
    director: '吴梦知',
    actors: ['宁静', '张雨绮', '王心凌'],
    region: '中国大陆',
    duration: '120分钟/期',
    episodes: 12,
    releaseDate: '2026-04-18',
    featured: false,
    isNew: true,
    isHot: true,
    slug: 'cheng-feng-po-lang-de-jie-jie-5',
  },
  {
    id: 8,
    title: '749局',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20sci-fi%20thriller%20movie%20poster%20showing%20a%20secret%20government%20facility%20entrance%20with%20military%20guards%2C%20dark%20stormy%20sky%2C%20searchlights%2C%20paranormal%20vibes%2C%20cinematic%20mystery%20aesthetic%20with%20blue-gray%20and%20warning%20red%20accents&width=800&height=600&seq=movie-08&orientation=landscape',
    description: '一个专门研究超自然现象的神秘机构——749局，在一次意外中发现了一个足以改变人类命运的秘密。年轻的探员们必须在真相与谎言之间做出选择。',
    director: '陆川',
    actors: ['王俊凯', '苗苗', '郑恺'],
    region: '中国大陆',
    duration: '135分钟',
    episodes: 1,
    releaseDate: '2026-03-08',
    featured: false,
    isNew: true,
    isHot: false,
    slug: '749-ju',
  },
  {
    id: 9,
    title: '与凤行',
    category: 'tv',
    subcategory: '仙侠',
    year: 2026,
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20xianxia%20fantasy%20drama%20poster%20with%20floating%20immortals%20in%20flowing%20silk%20robes%20among%20clouds%20and%20mountains%2C%20ethereal%20lighting%2C%20phoenix%20motifs%2C%20dreamy%20celestial%20atmosphere%20with%20peach%20blossom%20petals&width=800&height=600&seq=movie-09&orientation=landscape',
    description: '灵界碧苍王沈璃因逃婚跌落人间，意外结识了行止神君。两人从相识到相知，在神魔大战的背景下，展开了一段跨越三界的绝美仙侠之恋。',
    director: '邓科',
    actors: ['赵丽颖', '林更新'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: 39,
    releaseDate: '2026-03-18',
    featured: false,
    isNew: false,
    isHot: true,
    slug: 'yu-feng-xing',
  },
  {
    id: 10,
    title: '奔跑吧兄弟第十季',
    category: 'variety',
    subcategory: '真人秀',
    year: 2026,
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20outdoor%20variety%20show%20poster%20with%20a%20group%20of%20celebrities%20running%20and%20laughing%20in%20a%20colorful%20outdoor%20setting%2C%20action%20poses%2C%20bright%20sunny%20day%2C%20energetic%20and%20playful%20atmosphere&width=800&height=600&seq=movie-10&orientation=landscape',
    description: '全新一季的跑男团再度出发！他们走遍祖国大好河山，在趣味横生的游戏中挥洒汗水，为观众带来无尽的欢笑与感动。',
    director: '姚译添',
    actors: ['李晨', '郑恺', 'Angelababy', '白鹿'],
    region: '中国大陆',
    duration: '100分钟/期',
    episodes: 12,
    releaseDate: '2026-04-25',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'ben-pao-ba-xiong-di-10',
  },
  {
    id: 11,
    title: '大理寺少卿游',
    category: 'anime',
    subcategory: '动画',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20animated%20series%20poster%20with%20a%20cat%20official%20in%20ancient%20Chinese%20court%20robe%2C%20traditional%20palace%20setting%2C%20ink%20brush%20art%20style%2C%20mysterious%20and%20whimsical%20atmosphere%2C%20warm%20autumn%20colors&width=800&height=600&seq=movie-11&orientation=landscape',
    description: '唐朝武周时期，大理寺少卿李饼是一只能够说人话的白猫。他与同僚们一同破解京城中的离奇案件，在正义与邪恶的较量中守护一方平安。',
    director: '槐佳佳',
    actors: ['苏尚卿', '沈念如'],
    region: '中国大陆',
    duration: '25分钟/集',
    episodes: 24,
    releaseDate: '2026-02-14',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'da-li-si-shao-qing-you',
  },
  {
    id: 12,
    title: '狂飙2',
    category: 'tv',
    subcategory: '刑侦',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20crime%20thriller%20drama%20poster%20with%20two%20men%20facing%20off%20in%20a%20dark%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20tense%20atmosphere%2C%20film%20noir%20style%2C%20dark%20and%20moody%20with%20contrasting%20warm%20and%20cool%20tones&width=800&height=600&seq=movie-12&orientation=landscape',
    description: '扫黑除恶专项斗争持续深入，新一代政法干警接过前辈的旗帜，与隐藏在暗处的黑恶势力展开新一轮的较量。正义或许会迟到，但永远不会缺席。',
    director: '徐纪周',
    actors: ['张译', '张颂文'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: 40,
    releaseDate: '2026-07-01',
    featured: false,
    isNew: true,
    isHot: true,
    slug: 'kuang-biao-2',
  },
  {
    id: 13,
    title: '王牌对王牌第九季',
    category: 'variety',
    subcategory: '真人秀',
    year: 2026,
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20variety%20game%20show%20poster%20with%20two%20teams%20of%20celebrities%20competing%20on%20a%20colorful%20studio%20stage%2C%20confetti%20and%20lights%2C%20comedic%20and%20lively%20atmosphere%2C%20bright%20stage%20lighting&width=800&height=600&seq=movie-13&orientation=landscape',
    description: '王牌家族全员回归！经典游戏全新升级，特邀嘉宾阵容空前强大，笑声与泪水中，带领观众重温那些年的经典影视回忆。',
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    region: '中国大陆',
    duration: '90分钟/期',
    episodes: 12,
    releaseDate: '2026-01-15',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'wang-pai-dui-wang-pai-9',
  },
  {
    id: 14,
    title: '第二十条',
    category: 'movie',
    subcategory: '剧情',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20legal%20drama%20film%20poster%20showing%20a%20courtroom%20scene%20with%20judge%20bench%20and%20wooden%20seats%2C%20solemn%20atmosphere%2C%20natural%20light%20streaming%20through%20tall%20windows%2C%20dignified%20and%20thoughtful%20composition&width=800&height=600&seq=movie-14&orientation=landscape',
    description: '人到中年的检察官韩明，本想努力赶上职业生涯的末班车，却意外卷入了一桩分歧巨大的案件。在情与法的冲突中，他将如何坚守正义？',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖'],
    region: '中国大陆',
    duration: '141分钟',
    episodes: 1,
    releaseDate: '2026-04-30',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'di-er-shi-tiao',
  },
  {
    id: 15,
    title: '狐妖小红娘竹业篇',
    category: 'tv',
    subcategory: '仙侠',
    year: 2026,
    rating: 7.5,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20romance%20drama%20poster%20with%20a%20beautiful%20fox%20spirit%20woman%20in%20traditional%20red%20and%20white%20hanfu%2C%20cherry%20blossom%20trees%2C%20moonlit%20night%2C%20romantic%20and%20mystical%20atmosphere%2C%20soft%20ethereal%20glow&width=800&height=600&seq=movie-15&orientation=landscape',
    description: '在人妖共存的世界里，涂山狐妖一族以红娘为职业，为痴情的妖与人牵线搭桥。一段段跨越种族的爱情故事，在竹叶飘零间徐徐展开。',
    director: '杜林',
    actors: ['杨幂', '刘诗诗'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: 36,
    releaseDate: '2026-05-20',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'hu-yao-xiao-hong-niang-zhu-ye-pian',
  },
  {
    id: 16,
    title: '向往的生活第九季',
    category: 'variety',
    subcategory: '真人秀',
    year: 2026,
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20slow-life%20variety%20show%20poster%20with%20a%20cozy%20countryside%20courtyard%2C%20wooden%20house%2C%20vegetable%20garden%2C%20warm%20sunset%20lighting%2C%20peaceful%20rural%20atmosphere%2C%20natural%20and%20rustic%20charm&width=800&height=600&seq=movie-16&orientation=landscape',
    description: '黄磊和何炅带着新老朋友，再次回归田园生活。在青山绿水间，他们用双手劳作、用心烹饪，在慢生活中寻找最简单纯粹的快乐。',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴'],
    region: '中国大陆',
    duration: '90分钟/期',
    episodes: 14,
    releaseDate: '2026-04-01',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'xiang-wang-de-sheng-huo-9',
  },
  {
    id: 17,
    title: '深海2',
    category: 'anime',
    subcategory: '动画',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%20showing%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20a%20young%20girl%20floating%20in%20water%2C%20dreamlike%20underwater%20world%2C%20vibrant%20colors%20of%20coral%20and%20sea%20life%2C%20surreal%20and%20emotional%20atmosphere&width=800&height=600&seq=movie-17&orientation=landscape',
    description: '参宿再次潜入深海世界，这一次她遇到了更多奇妙的海洋生物和神秘的深海文明。在这片绚烂多彩的水下世界中，一段关于勇气与成长的奇幻旅程即将启程。',
    director: '田晓鹏',
    actors: ['王婷', '苏鑫'],
    region: '中国大陆',
    duration: '120分钟',
    episodes: 1,
    releaseDate: '2026-06-01',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'shen-hai-2',
  },
  {
    id: 18,
    title: '人生大事2',
    category: 'movie',
    subcategory: '剧情',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20family%20drama%20film%20poster%20with%20a%20father%20and%20young%20daughter%20walking%20hand%20in%20hand%20on%20a%20quiet%20street%2C%20golden%20hour%20sunset%20lighting%2C%20warm%20and%20touching%20atmosphere%2C%20slice%20of%20life%20cinematography&width=800&height=600&seq=movie-18&orientation=landscape',
    description: '殡葬师莫三妹在经历了人生的起起伏伏后，再次面对生与死的课题。一次偶然的相遇，让他重新思考生命的意义与亲情的珍贵。',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又'],
    region: '中国大陆',
    duration: '130分钟',
    episodes: 1,
    releaseDate: '2026-08-15',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 'ren-sheng-da-shi-2',
  },
  {
    id: 19,
    title: '三体：大史',
    category: 'tv',
    subcategory: '科幻',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20drama%20poster%20with%20cosmic%20backdrop%20of%20galaxies%20and%20stars%2C%20a%20detective%20silhouette%20against%20the%20universe%2C%20mysterious%20alien%20signal%20visualization%2C%20deep%20space%20colors%2C%20mind-bending%20conceptual%20art&width=800&height=600&seq=movie-19&orientation=landscape',
    description: '纳米科学家汪淼在警官史强的引导下，逐渐揭开了"科学边界"组织背后隐藏的秘密。一个来自三体文明的信息，将彻底改变人类对宇宙的认知。',
    director: '杨磊',
    actors: ['于和伟', '张鲁一', '陈瑾'],
    region: '中国大陆',
    duration: '50分钟/集',
    episodes: 30,
    releaseDate: '2026-01-15',
    featured: false,
    isNew: false,
    isHot: true,
    slug: 'san-ti-da-shi',
  },
  {
    id: 20,
    title: '热辣滚烫2',
    category: 'movie',
    subcategory: '喜剧',
    year: 2026,
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20film%20poster%20with%20a%20woman%20boxing%20in%20a%20gym%2C%20sweat%20and%20determination%2C%20warm%20lighting%2C%20inspiring%20underdog%20story%20vibe%2C%20vibrant%20and%20energetic%20composition&width=800&height=600&seq=movie-20&orientation=landscape',
    description: '乐莹在经历了人生的低谷后，通过拳击找到了新的人生方向。这一次，她不再是讨好别人的"老好人"，而是要为自己的人生打出一记漂亮的重拳。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    region: '中国大陆',
    duration: '129分钟',
    episodes: 1,
    releaseDate: '2026-07-20',
    featured: false,
    isNew: false,
    isHot: false,
    slug: 're-la-gun-tang-2',
  },
];

export const subcategories: Record<string, string[]> = {
  movie: ['全部', '科幻', '奇幻', '战争', '剧情', '喜剧', '动作', '悬疑', '爱情', '动画'],
  tv: ['全部', '古装', '奇幻', '仙侠', '刑侦', '科幻', '都市', '悬疑', '爱情', '历史'],
  variety: ['全部', '真人秀', '脱口秀', '音乐', '舞蹈', '竞技', '美食', '旅行'],
  anime: ['全部', '热血', '搞笑', '奇幻', '恋爱', '治愈', '科幻', '日常'],
};